import script from "./RegisterPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./RegisterPage.vue?vue&type=script&setup=true&lang=ts"

import "./RegisterPage.vue?vue&type=style&index=0&id=0632d476&lang=css"

const __exports__ = script;

export default __exports__